const proxyMouseUpToParentContext = (event) => {
  const { ownerDocument } = event.target;
  const { frameElement } = ownerDocument ? ownerDocument.defaultView : {};

  if (!frameElement) {
    return;
  }

  const mouseUpEvent = new MouseEvent('mouseup', {
    bubbles: true,
    cancelable: true,
  });

  frameElement.dispatchEvent(mouseUpEvent);
};

export default proxyMouseUpToParentContext;
